<ul class="flex">
	@for (avatar of avatars() | slice: 0 : maximumAvatars(); track avatar.id) {
		<li [ngClass]="listItemClasses()">
			<ui-avatar
				[size]="size()"
				shape="circle"
				[src]="avatar.src"
				[initials]="avatar.initials"
				[tooltipText]="avatar.tooltipText"
				[variant]="variantOrderList[$index % variantOrderList.length]"
			/>
		</li>
	}
	@if (excessAvatar()) {
		<li [ngClass]="listItemClasses()">
			<ui-avatar
				[size]="size()"
				shape="circle"
				[initials]="excessAvatar().initials"
				[tooltipText]="excessAvatar().tooltipText"
			/>
		</li>
	}
</ul>
